module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/assets/icon/font-awesome/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/assets/icon/font-awesome/fonts/fontawesome-webfont.eot
// module chunks = styles